import { initPageSlider } from './page-slider.js';
import { syncHeroMedia } from './sections/hero-media.js';
import { syncPersonagens } from './sections/personagens.js';
import { syncGalleries } from './sections/galeria.js';
import { syncSinopse } from './sections/sinopse.js';
import { syncSectionReveals } from './sections/section-reveals.js';
import { initTeasers } from './sections/teaser.js';
import { initMobileTicketButton, syncMobileTicketButton } from './sections/mobile-ticket-button.js';
import { initVideoAnnouncementBarPin, syncVideoAnnouncementBarPin } from './sections/video-announcement-bar-pin.js';

let resizeRaf = null;

function evaluate() {
  syncHeroMedia();
  syncSectionReveals();
  syncVideoAnnouncementBarPin();
  syncMobileTicketButton();
  syncSinopse();
  syncPersonagens();
  syncGalleries();
}

function finishFirstLoad() {
  document.documentElement.classList.add('sections-ready');
  requestAnimationFrame(() => {
    evaluate();
  });
}

function initNewsletterForms() {
  let toast = document.querySelector('.newsletter-form__toast');

  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'newsletter-form__toast';
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    toast.hidden = true;
    document.body.append(toast);
  }

  let hideTimer = null;

  const showToast = (message, state = 'success') => {
    if (hideTimer) {
      clearTimeout(hideTimer);
    }

    toast.hidden = false;
    toast.dataset.state = state;
    toast.classList.remove(
      'newsletter-form__toast--error',
      'newsletter-form__toast--pending',
      'newsletter-form__toast--success'
    );
    toast.classList.add(`newsletter-form__toast--${state}`);
    toast.textContent = message;
    requestAnimationFrame(() => {
      toast.classList.add('newsletter-form__toast--visible');
    });

    hideTimer = window.setTimeout(() => {
      toast.classList.remove('newsletter-form__toast--visible');
      hideTimer = window.setTimeout(() => {
        toast.hidden = true;
      }, 220);
    }, 3200);
  };

  for (const form of document.querySelectorAll('.listmonk-form')) {
    const submit = form.querySelector('.newsletter-form__submit');
    const email = form.querySelector('input[type="email"]');

    if (!submit) {
      continue;
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      submit.disabled = true;
      showToast('Enviando...', 'pending');

      try {
        await fetch(form.action, {
          method: 'POST',
          mode: 'no-cors',
          body: new URLSearchParams(new FormData(form)),
        });

        form.reset();
        if (email) {
          email.focus();
        }

        showToast('Inscrição enviada. Confira seu e-mail.');
      } catch {
        showToast('Não foi possível enviar agora.', 'error');
      } finally {
        submit.disabled = false;
      }
    });
  }
}

function bootstrapPage() {
  initNewsletterForms();
  initPageSlider();
  initTeasers();
  initMobileTicketButton();
  initVideoAnnouncementBarPin();
  syncSectionReveals();

  requestAnimationFrame(() => {
    syncVideoAnnouncementBarPin();
    syncMobileTicketButton();
    evaluate();
    finishFirstLoad();
  });
}

function onResize() {
  if (resizeRaf) {
    cancelAnimationFrame(resizeRaf);
  }

  resizeRaf = requestAnimationFrame(() => {
    evaluate();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  bootstrapPage();
  window.addEventListener('resize', onResize);
  window.addEventListener('load', evaluate, {
    once: true,
  });
});
